export type IllustrationKey =
  | "chart"
  | "chartDown"
  | "document"
  | "shield"
  | "search"
  | "alert"
  | "analytics"
  | "compare";

const svgMap: Record<IllustrationKey, string> = {
  chart: "/images/illustrations/chart.svg",
  chartDown: "/images/illustrations/chartDown.svg",
  document: "/images/illustrations/document.svg",
  shield: "/images/illustrations/shield.svg",
  search: "/images/illustrations/search.svg",
  alert: "/images/illustrations/alert.svg",
  analytics: "/images/illustrations/analytics.svg",
  compare: "/images/illustrations/compare.svg",
};

export default function FeatureIllustration({
  name,
}: {
  name: IllustrationKey;
}) {
  const src = svgMap[name];
  if (!src) return null;
  return (
    <div className="relative w-full max-w-[220px] sm:max-w-[280px] lg:max-w-[340px] mx-auto">
      <div
        className="absolute inset-[-10%] rounded-full bg-gradient-to-br from-black/[0.04] via-black/[0.02] to-transparent blur-2xl pointer-events-none"
        aria-hidden="true"
      />
      <div className="relative aspect-square">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src={src} alt="" className="w-full h-full" loading="lazy" />
      </div>
    </div>
  );
}
